module.exports = __webpack_public_path__ + "static/media/341SunsetAveNW_2018-06-11_70.0d386030.jpg";